<template>
  <div>
    <v-overlay :value="$store.state.isloading">
      <v-progress-circular indeterminate size="64">
        <span v-if="$store.state.isloading" style="font-size:15px;">Por favor aguarde</span>
      </v-progress-circular>
    </v-overlay>
    <v-card style="margin-top:30px;">
      <v-row>
        <v-col md="3">
          <v-autocomplete v-model="editedItem.instituicao" item-value="idInstituicao" item-text="descricao"
            :items="instituicoes" label="Selecione a instituição" :readonly="false" persistent-hint prepend-icon="home"
            @change="obterPlanocurricular()" return-object>
          </v-autocomplete>
        </v-col>
        <v-col md="3">
          <v-select :items="Listaranoslectivo" v-model="editedItem.anolectivo" item-value="descricao"
            item-text="novadescricao" label="Selecione o Ano lectivo" @change="obterPlanocurricular()"
            return-object></v-select>
        </v-col>
        <v-col md="3">
          <v-select :items="cursos" v-model="editedItem.curso" item-value="idCurso" item-text="descricao"
            label="Selecione o Curso" @change="obterPlanocurricular()" return-object></v-select>
        </v-col>
        <v-col md="3">
          <v-select :items="classes" v-model="editedItem.classe" item-value="id" item-text="descricao"
            label="Selecione a Classe" @change="obterPlanocurricular()" return-object></v-select>
        </v-col>
      </v-row>
    </v-card>
    <br>
    <v-row>
      <v-col md="6">
        <v-data-table style="width:700px;margin-left:10px;" :headers="headers" :items="pautas" hide-default-footer
          :items-per-page="30">
          <template v-slot:top>
            <v-toolbar-title>
              Disciplinas da pauta
              <v-btn @click="removeDisciplinas()" color="red" style="color:white;" small v-if="lixeira.length">
                Eliminar disciplina(s)
                <v-icon small>delete</v-icon>
              </v-btn>
            </v-toolbar-title>
          </template>
          <template v-slot:item.disciplina="{ item }">
            <span :style="item.disciplinaErrada === 1 ? 'color:red' : ''">{{ item.disciplina }}</span>
          </template>
          <template v-slot:item.idCurso="{ item }">
            <span :style="item.disciplinaErrada === 1 ? 'color:red' : ''">{{ editedItem.curso.descricao }}</span>
          </template>
          <template v-slot:item.classe="{ item }">
            <span :style="item.disciplinaErrada === 1 ? 'color:red' : ''">{{ editedItem.classe.descricao }}</span>
          </template>
          <template v-slot:item.anolectivo="{ item }">
            <span :style="item.disciplinaErrada === 1 ? 'color:red' : ''">{{ item.anolectivo }}</span>
          </template>
          <template v-slot:item.iddisciplina="{ item }">
            <span :style="item.disciplinaErrada === 1 ? 'color:red' : ''">{{ item.iddisciplina }}</span>
          </template>
          <!-- <template v-slot:item.action="{ item }">
              <v-icon  color="green" class="mr-2" v-if="item.estado" @click="addItem(item, false)">check</v-icon>
              <v-btn v-if="!item.estado && item.disciplinaErrada ===1" small color="red">
                <v-icon  color="white" class="mr-2"  @click="addItem(item, true)">close</v-icon></v-btn>
          </template> -->
        </v-data-table>
      </v-col>
      <v-col md="6">
        <v-data-table style="width:700px;margin-right:10px;" hide-default-footer :headers="headersf" :items-per-page="30"
          :items="curriculo">
          <template v-slot:item.idcurso="{ item }">
            <span>{{ editedItem.curso.descricao }}</span>
          </template>
          <template v-slot:item.anoacademico="{ item }">
            <span>{{ editedItem.classe.descricao }}</span>
          </template>
          <template v-slot:top>
            <v-toolbar-title>
              Plano curricular

            </v-toolbar-title>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import axios from '../../../plugins/axios'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    instituicoes: [],
    isLoading: false,
    Listaranoslectivo: [],
    curriculo: [],
    pautas: [],
    cursos: [],
    classes: [{ id: 1, descricao: '10ª' }, { id: 2, descricao: '11ª' }, { id: 3, descricao: '12ª' }, { id: 4, descricao: '13ª' }],
    editedItem: {
      anolectivo: null,
      classe: null,
      curso: null,
      instituicao: ''
    },
    lixeira: [],
    headers: [
      { text: 'ID', value: 'iddisciplina' },
      { text: 'Disciplinas', value: 'disciplina' },
      { text: 'Curso', value: 'idCurso' },
      { text: 'Classe', value: 'classe' },
      { text: 'Ano Lectivo', value: 'anolectivo' },
      // { text: 'Actions', value: 'action', sortable: false }
    ],

    headersf: [
      { text: 'ID', value: 'iddisciplina' },
      { text: 'Disciplinas', value: 'descricao' },
      { text: 'Curso', value: 'idcurso' },
      { text: 'Classe', value: 'anoacademico' }

    ],

  }),

  computed: {},
  watch: {},
  created() {
    this.loadAnosLectivo()
    this.loadCursos()
    this.loadInstituicoes()
  },
  methods: {
    async loadInstituicoes() {
      try {
        this.instituicoes = await axios
          .get('/listarInstituicao')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.sair()
        Swal.fire('Informação', 'Ocorreu um erro ao efectuar a operação', 'error')
      }
    },
    async loadAnosLectivo() {
      try {
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)

      } catch (error) {
        this.sair()
        Swal.fire('Informação', 'Ocorreu um erro ao efectuar a operação', 'error')
      }
    },
    async loadCursos() {
      try {
        this.cursos = await axios
          .get('/cursoAll')
          .then(res => res.data)
      } catch (error) {
        this.sair()
        Swal.fire('Informação', 'Ocorreu um erro ao efectuar a operação', 'error')
      }
    },
    async obterPlanocurricular() {
      this.lixeira = []
      try {
        if (this.editedItem.instituicao && this.editedItem.anolectivo && this.editedItem.curso && this.editedItem.classe) {
          this.$store.state.isloading = true
          this.curriculo = await axios
            .post('/obterPlanocurricularCursoAnoLectivoClasse', this.editedItem)
            .then(res => res.data)
          this.loadDisciplinasOnPauta()
        }

      } catch (error) {
        this.sair()
        Swal.fire('Informação', 'Ocorreu um erro ao efectuar a operação', 'error')
      }
    },
    async loadDisciplinasOnPauta() {
      try {
        if (this.editedItem.instituicao && this.editedItem.anolectivo && this.editedItem.curso && this.editedItem.classe) {
          this.$store.state.isloading = true
          this.pautas = await axios
            .post('/obterDisciplinasOnPautaByCursoAnoLectivoClasse', this.editedItem)
            .then(res => res.data)
          this.verificaDisciplinasErradas()
          this.sair()
        } else {
          Swal.fire('Informação', 'Selecione os campos em falta', 'warning')
        }

      } catch (error) {
        this.sair()
        Swal.fire('Informação', 'Ocorreu um erro ao efectuar a operação', 'error')
      }
    },

    verificaDisciplinasErradas() {

      this.pautas.forEach(element => {
        let index = this.pautas.indexOf(element)
        let disciplinaExistente = this.curriculo.filter(d => parseInt(d.iddisciplina) == (element.iddisciplina))
        if (!disciplinaExistente.length) {
          this.pautas[index].disciplinaErrada = 1
          this.addItem(element, true)
        }
      });


    },

    async addItem(item, isAdd) {
      try {
        if (isAdd) {
          this.pautas[this.pautas.indexOf(item)].estado = true
          this.lixeira.push(item)
        } else {
          this.pautas[this.pautas.indexOf(item)].estado = false
          let index = this.lixeira.indexOf(item)
          this.lixeira.splice(index, 1)
        }
      } catch (error) {
        this.sair()
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro' })
      }
    },
    async removeDisciplinas() {
      try {
        Swal.fire({
          title: "Desejas continuar essa operação?",
          text: "Os dados serão eliminados permanentemente",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Continuar",
          reverseButtons: true
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              this.$store.state.isloading = true
              let msg = await axios.post('/eliminarDisciplinas', this.lixeira).then(res => res.data)
              if (msg.affectedRows > 0) {
                this.lixeira = []
                this.loadDisciplinasOnPauta()
                Swal.fire({ title: "Informação", text: "Disciplinas eliminadas com sucesso", icon: "success" });
              } else
                this.sair()
            } catch (error) {
              this.sair()
              Swal.fire({ title: "Informação", text: "Ocorreu um erro", icon: "error" });
            }

          }
        });
      } catch (error) {
        this.sair()
      }
    },
    sair() {
      this.$store.state.isloading = false
    }
  }

}

</script>
